export default {
  club_name: 'HamKam',
  club_name_short: 'hamkam',
  stadium_name: '',
  staging_url: 'https://hamkam.api.fangroup.io',
  prod_url: 'https://hamkam.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/hamkam',
  club_logo: '/assets/teams/hamkam.png',
  app_name: 'hamkam',
  websale_name: 'hamkam',
  ntb_team_id: 10064,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'NOK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'hamkam',
  monolithEnabled: false,
};
